export class OrganisationGroupOrganisationModel {
    public organisationGroupOrganisationId: string
    public organisationId: string;
    public organisationGroupCode: string;
}